import React from "react";
import { ReactComponent as Closy } from "assets/svgs/closy.svg";
import Tabs from "components/tabs";
import IngredientsTab from "./tabs/ingredients";
import NutritionsTab from "./tabs/nutritions";
import BundleProducts from "components/bundle-products";
import { useGlobalContext } from "context/global";

const Content = ({ data, closeModal }) => {
	const { translation } = useGlobalContext();

	return (
		<>
			<div className="styled-modal-header !p-4 md:!p-8">
				<div className="w-full m-auto">
					<Tabs
						className="gap-5 my-4 md:mr-3"
						tabClassName="!w-1/3 tab-title"
						tabs={[
							{
								label: translation.product?.products,
								content: <BundleProducts products={data?.product?.details?.products}
									total={data?.product?.details?.total_bundle_products} />
							},
							{
								label: translation.product.ingredients,
								content: <IngredientsTab data={data} />
							},
							{
								label: translation.product.nutritions,
								content: <NutritionsTab data={data} />
							},
						]} />
				</div>
				<button className="absolute top-2 right-2 md:top-4 md:right-4" onClick={closeModal}>
					<Closy />
				</button>
			</div>
		</>
	);
};

export default Content;
